"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Details = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const useIsFirstRender_1 = __importDefault(require("../hooks/useIsFirstRender"));
const Details_module_css_1 = __importDefault(require("./Details.module.css"));
const ChevronIcon_1 = require("./icons/ChevronIcon");
/**
 * Custom styled details / toggle component
 */
function Details(props) {
    const childrenClassname = (0, clsx_1.default)({ [Details_module_css_1.default.indentChildren]: props.indentChildren });
    const isFirst = (0, useIsFirstRender_1.default)();
    return ((0, jsx_runtime_1.jsxs)("details", { onToggle: (event) => {
            !isFirst && props.onToggle?.(event);
        }, className: Details_module_css_1.default.details, open: props.defaultOpen, "data-label": props.dataLabel, title: props.summary, children: [(0, jsx_runtime_1.jsxs)("summary", { className: Details_module_css_1.default.summary, children: [props.summary, " ", (0, jsx_runtime_1.jsx)("span", { className: Details_module_css_1.default.arrow, children: (0, jsx_runtime_1.jsx)(ChevronIcon_1.ChevronIcon, {}) })] }), (0, jsx_runtime_1.jsx)("div", { className: childrenClassname, children: props.children })] }));
}
exports.Details = Details;
//# sourceMappingURL=Details.js.map